<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="data-collection-mapping tile-header">
          <h3 class="title">{{ "teams.dataCollectionMapping.title" | translate }}</h3>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>


    <form [formGroup]="configurationForm">
      <div class="configuration-fields" formArrayName="configurationFields">
        <div class="remap-form" *ngFor="let remapForm of configurationFields.controls; let index = index" [formGroupName]="index">
          <div class="remap-fields">
            <mat-form-field class="collected-field">
              <mat-select
                formControlName="collectedField"
                placeholder="{{ 'teams.dataCollectionMapping.CollectedFields.Placeholders.CollectedField' | translate }}"
              >
                <mat-option *ngFor="let option of collectedFields | keyvalue" [value]="option.value" [disabled]="isFieldDisable(option.value)">
                  {{ getCollectedFieldText(option.value) }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field>
              <input
                matInput
                formControlName="remapValue"
                placeholder="{{ 'teams.dataCollectionMapping.CollectedFields.Placeholders.RemapTo' | translate }}"
              />
            </mat-form-field>
          </div>

          <button class="remove-field" mat-icon-button (click)="removeField(index)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </form>

    <button *ngIf="!isAllFieldExist" class="add-field-button" mat-button (click)="addFields()">
      <mat-icon>add</mat-icon>
      <span>{{ "teams.dataCollectionMapping.Add" | translate }}</span>
    </button>
  </mat-expansion-panel>
</mat-accordion>
